import { render, staticRenderFns } from "./publishPic.vue?vue&type=template&id=631b6223&scoped=true"
import script from "./publishPic.vue?vue&type=script&lang=js"
export * from "./publishPic.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/publish.css?vue&type=style&index=0&id=631b6223&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b6223",
  null
  
)

export default component.exports